import { BusinessTableRow } from '../types/add_commerce.types';
import { UpdateBusinessTerminalRequest } from '../types/business/request';
import { BusinessPromotionEnum } from '../types/enums/promotion-enum';
import { TaxPayerTypeDescriptionsEnum } from '../types/enums/taxpayer-type.enum';
import { BusinessTerminal } from '../types/terminals/model';
import { initialIntegratorsNotCurrentlyIncluded } from './data';

export const getTerminalFromValues = (values: any, previousTerminals: BusinessTerminal[] = []) => {
  const previousQuantityByType = new Map(
    previousTerminals.map((terminal) => [String(terminal.type), Number(terminal.quantity) || 0]),
  );

  if (values.terminals[0]?.rows) {
    const currentIds = new Set(values.terminals[0].rows.map((r: BusinessTableRow) => String(r.id)));

    const terminals = values.terminals[0].rows.filter((terminal: BusinessTableRow) => {
      const type = String(terminal.id);
      const currentQuantity = Number(terminal.currency) || 0;
      const previousQuantity = previousQuantityByType.get(type) || 0;

      return currentQuantity > 0 || (previousQuantity > 0 && currentQuantity === 0);
    });

    const formattedCurrent = terminals.map((terminal: BusinessTableRow) => {
      const type = String(terminal.id);
      const currentQuantity = Number(terminal.currency) || 0;
      const previousQuantity = previousQuantityByType.get(type) || 0;
      const isDelete = previousQuantity > 0 && currentQuantity === 0;

      return {
        type,
        quantity: isDelete ? previousQuantity : currentQuantity,
        UIPrice: +terminal.fees,
        delete: isDelete,
      };
    });

    const orphanDeletes = previousTerminals
      .filter((t) => !currentIds.has(String(t.type)) && Number(t.quantity) > 0)
      .map((t) => ({
        type: String(t.type),
        quantity: Number(t.quantity),
        UIPrice: t.price,
        delete: true,
      }));

    return [...formattedCurrent, ...orphanDeletes];
  } else if (values.terminals) {
    return values.terminals
      .filter((terminal: BusinessTerminal) => Number(terminal.quantity) > 0)
      .map((terminal: BusinessTerminal) => ({
        type: terminal.type,
        quantity: +terminal.quantity,
        UIPrice: terminal.price,
        delete: false,
      }));
  }

  return [];
};

// TODO: provisional solution for coexistence of initial integrators and integrators modification requested
export const assignIntegration = (localState: any) => {
  if (!localState.integration) {
    return '0';
  }

  const initialIntegratorsNotCurrentlyIncludedValues = initialIntegratorsNotCurrentlyIncluded.map(
    (integrator) => integrator.value,
  );

  if (initialIntegratorsNotCurrentlyIncludedValues.includes(localState.integration)) {
    return '106'; // "Otros"
  }

  return localState.integration;
};

export const evaluateIfBusinessHasPromotion = (values: any): string => {
  if (values.posSale === 'true') {
    return values.promotion;
  }

  return '';
};

export const getIntegrationTypesValues = (integrationTypes: any[]): number[] => {
  const integrationTypeValues = integrationTypes.map((integrationType) => {
    return integrationType.id;
  });

  return integrationTypeValues;
};

export const getBusinessPromotion = (localState: any): string => {
  const allowedTaxpayersForDmrPromotion = [
    TaxPayerTypeDescriptionsEnum.MONOTRIBUTO,
    TaxPayerTypeDescriptionsEnum.MONOTRIBUTO_MIDES,
    TaxPayerTypeDescriptionsEnum.PEQUEÑA_EMPRESA,
  ];

  if (!localState.nadOnboarding) {
    return BusinessPromotionEnum.PROMO_2_MESES;
  }  

  if (allowedTaxpayersForDmrPromotion.includes(localState?.taxpayerType?.description)) {

    if(new Date(localState.createdAt) < new Date('2025-11-01')){
      return BusinessPromotionEnum.PROMO_12_MESES_DMR;
    }
    
    return BusinessPromotionEnum.PROMO_6_MESES_DMR;
  }

  return BusinessPromotionEnum.PROMO_6_MESES;
};

export const buildTerminalRequestBody = ({
  values,
  formattedTerminals,
  integrationTypeValues,
  noPosSaleComments,
}: {
  values: any;
  localState: any;
  formattedTerminals: any;
  integrationTypeValues: any;
  noPosSaleComments: any;
}): UpdateBusinessTerminalRequest => ({
  ecommerce: values.ecommerce,
  ecommerceProcessor: values?.paymentProcessor,
  ecommerceIntegrationType: integrationTypeValues,
  integration: values.integration,
  commercialCenter: values.commercialCenter,
  wantsIntegratedPos: values.wantsIntegratedPos,
  terminals: formattedTerminals,
  nadServicePayment: values.settlement,
  promotion: evaluateIfBusinessHasPromotion(values),
  shippingType: values.shippingType,
  shipping:
    !values.wantsIntegratedPos && values.commercialCenter === 'NO' && values.posSale === 'true'
      ? !values.withdrawInGetnet
      : false,
  posSale: values.posSale === 'true' ? 'SI' : 'NO',
  noPosSaleComments: noPosSaleComments,
  shippingAddress: {
    courier: values.withdrawInGetnet ? '' : values.courier,
    neighborhood: '',
    addressStreet: values.withdrawInGetnet ? '' : values.addressStreet,
    addressNumber: values.withdrawInGetnet ? '' : values.addressNumber,
    addressFlatNumber: values.withdrawInGetnet ? '' : values.addressFlatNumber,
    addressSolar: values.withdrawInGetnet ? '' : values.addressSolar,
    addressPlot: values.withdrawInGetnet ? '' : values.addressPlot,
    schedule: values.withdrawInGetnet ? '' : values.deliveryTime,
    contactPhone: values.withdrawInGetnet ? '' : values.phoneNumber,
    city: values.withdrawInGetnet ? '' : values.cityId,
  },  
  insurancesIds: values.insurancesIds.length > 0 ? values.insurancesIds : [],
  ...(values.electronicInvoicing ? { type: values.electronicInvoicingType } : {}),
});
